<template>
    <div style="margin: 10px 10px 10px 20px;overflow:hidden">
        <div class="search-bar-comm-style pt-2" style="width:100%;display:inline-block">
            <input
                type="text"
                class="rounded text-light search-bar"
                :placeholder="$t('Search language name')"
                autocomplete="off" v-model="searchKeyword"
                style="margin: 0px 15px"/>
        </div>
        <div class="language-table-main-wrapper">
            <table class="tabletable-with-border table-scroll small-first-col table-cell-styles" style="width:100%">
                <thead>
                    <tr style="height:35px;">
                        <th style="text-align:start;width:10%">{{$t('Language Code')}}</th>
                        <th style="text-align:start;width:20%">{{$t('Language Name')}}</th>
                        <th style="12%">{{$t('LTR')}}/{{$t('RTL')}}</th>
                        <th style="14%">{{$t('Language Mapper')}}</th>
                        <th style="22%">{{$t('Modified On')}}</th>
                        <th style="14%">{{$t('Status')}}</th>
                        <th style="width:8%"></th>
                        <!-- <th>{{$t('Action')}}</th> -->
                    </tr>
                </thead>
                <tbody>
                    <template  v-for="language in filterLangList">
                        <tr :key="language._id" class="comm-user-row show-delete-icon" :disabled="language.code == 'en'?true:false">
                            <td style="text-align:start">{{language.code}}</td>
                            <td style="text-align:start">{{language.name}}</td>
                            <!-- <td>{{language.LanguageOrientation}}</td> -->
                                <Multiselect
                                    v-model="language.orientation"
                                    :options="languageOrientationOptions"
                                    :searchable="false"
                                    :allow-empty="false"
                                    :show-labels="false"
                                    :close-on-select="true"
                                    placeholder="Select"
                                    class="language-orientation-select"
                                    @open="storePreviousOrientation(language)"
                                    @select="updateLanguageOrientation($event, language)"
                                ></Multiselect>
                            <td>{{language.mapper_type}}</td>
                            <td :title="getDateAndTimeInConfiguredFormat(language.modified_datetime)">{{getDateAndTimeInConfiguredFormat(language.modified_datetime, true)}}</td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" v-model="language.enabled" @click="updateLanguageReset('enabled', language._id, $event.target.checked)"
                                    class="custom-control-input" :id="language._id" :checked="language.enabled === true" :disabled="language.code == 'en'?true:false">
                                    <label class="custom-control-label" :for="language._id">
                                    </label>
                                </div>
                            </td>
                            <td style="position: relative;display:inline-flex;justify-content:center">
                                <div v-if="language.code != 'en'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-upload parent-row-edit" viewBox="0 0 16 16">
                                        <title>{{$t('Upload')}}</title>
                                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                                        <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"/>
                                    </svg>
                                    <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:70px">
                                        <input type="file"
                                            id="img-input"
                                            :ref="'uploadFile_'+language._id"
                                            v-on:click="resetImageUploader(language._id)"
                                            v-on:change="uploadLanguageMapperFile($event, language._id)"
                                            accept=".csv"
                                            :title="$t('Upload')"
                                            style="height: 100%;display: inline-block;width: 100%;">
                                    </div>        
                                </div>    
                                <div v-if="language.code != 'en'">
                                    <svg @click="downloadLangugaeMapper(language._id, language.name)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download parent-row-edit" viewBox="0 0 16 16">
                                        <title>{{$t('Download')}}</title>
                                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
                                    </svg>
                                </div>    
                                <svg v-if="language.code != 'en'" @click="updateLanguageReset('mapper_type', language._id)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise parent-row-edit" viewBox="0 0 16 16">
                                    <title>{{$t('Reset')}}</title>
                                    <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                                </svg>
                                
                               
                                <!-- <svg @click.stop.prevent="deleteBin(key.bin_id)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-trash parent-row-edit" viewBox="0 0 16 16">
                                    <title>Delete</title>
                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                    <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                </svg> -->
                            </td>
                        </tr>
                    </template>    
                </tbody>
            </table>
        </div>
    </div>    
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Constants from "../../components.constants.js";
import {NotifierConstants} from "../../components.constants.js";
import Utils from '../../components.utils.js';
import Multiselect from "vue-multiselect";
import axios from "axios";

    export default { 
        data(){
            return{
                languagesList:[],
                searchKeyword:null,
                languageOrientationOptions: ["LTR", "RTL"],
            }
        },

        components: {
            Multiselect,
        },  

        created(){
            this.addWSEventListener({ eventname:[NotifierConstants.languageUpdated], callback:this.handleNotification,parent:"languageSettings"})
            this.getLanguagesList();
        },
        beforeDestroy(){
            this.removeWSEventListener({ eventname:[NotifierConstants.languageUpdated], callback:this.handleNotification,parent:"languageSettings"})
        },
        computed:{
            filterLangList(){
                if(this.searchKeyword && this.searchKeyword.trim().length > 0){
                    return this.languagesList.filter(op=>op.name.toLowerCase().startsWith(this.searchKeyword.toLowerCase().trim()))
                }
                return this.languagesList
            },
        },
        
        methods:{
            isEnabled(priv) {
                return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(), priv);
            },
            getLanguagesList(){
                this.getlangaugesDetailsFromServer().then((data)=>{
                    this.languagesList = data.languages;
                });
            },
            
            downloadLangugaeMapper(languageId, languageName){
                // let payload = {"languageId":languageId};
                let downnloadUrl = `${Constants.languageURL}/download-mapper/${languageId}`;
                // this.downloadlangaugesMapperFromServer().then((data)=>{
                    const link = document.createElement("a");
                    link.href = downnloadUrl;
                    link.download = languageName;
                    link.click(); 
                    
                    console.log("Download initiated");

                // });
            },
            
            uploadLanguageMapperFile(event, languageId){
                this.$toast.info("Successfully submitted Upload language mapper request");
                let formData = new FormData();
                let selectedFileInfo = this.$refs["uploadFile_"+languageId][0].files[0];
                formData.append("file", selectedFileInfo);
                // formData["mapper_file_path"] = "language mapper";
                axios.put(`${Constants.languageURL}/upload-mapper/${languageId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                    }
                }).then(function(){
                    console.log('SUCCESS!!');
                })
                .catch(function(){
                    console.log('FAILURE!!');
                });
            },

            resetImageUploader(languageId){
                this.$refs["uploadFile_"+languageId].value = '';
            },

            updateLanguageReset(fieldName, languageId, stateStatus){
                let payload = {"languageId":languageId};
                let params = {};
                if(fieldName =='enabled'){
                    params[fieldName] = stateStatus;
                }else if(fieldName == 'mapper_type'){
                    params[fieldName] = "NA";
                }
                payload["params"] = params;
                this.updateLanguageWithResetFromServe(payload).then((data)=>{
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        if(data.message){
                            this.$toast.success(data.message);
                        }else{
                            this.$toast.success("Updated");
                        } 
                    } else {
                         if(fieldName == 'enabled'){
                            let index = this.languagesList.findIndex(op=>op._id == languageId)
                            this.languagesList[index].enabled = !stateStatus;
                        }
                        if(data.message){
                            this.$toast.error(data.message);
                        }else{
                            this.$toast.error("Failed");
                        }
                    }
                });
            },
            storePreviousOrientation(language) {
                this.$set(
                    language,
                    "_previousLanguageOrientation",
                    language.orientation
                );
            },

            updateLanguageOrientation(selectedOrientation, language) {
                if (
                    selectedOrientation ===
                    language._previousLanguageOrientation
                ) {
                    return;
                }

                const payload = {
                    languageId: language._id,
                    params: {
                        orientation: selectedOrientation,
                    }
                };

                this.updateLanguageWithResetFromServe(payload)
                    .then((data) => {
                        if (Utils.isAcceptedStatusCode(data.statusCode)) {
                            this.$set(
                                language,
                                "orientation",
                                selectedOrientation
                            );

                            this.$set(
                                language,
                                "_previousLanguageOrientation",
                                selectedOrientation
                            );

                            this.$toast.success(data.message || "Updated");
                        } else {
                            this.$set(
                                language,
                                "orientation",
                                language._previousLanguageOrientation
                            );

                            this.$toast.error(data.message || "Failed");
                        }
                    })
                    .catch(() => {
                        this.$set(
                            language,
                            "orientation",
                            language._previousLanguageOrientation
                        );

                        this.$toast.error("Failed");
                    });
            },

            handleNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    let entry_info = notification.message;
                    let indx = this.languagesList.findIndex(op=>op._id == entry_info._id)
                    if(indx >= 0){
                        this.$set(this.languagesList[indx], "enabled", entry_info.enabled)
                        if('mapper_file_path' in entry_info){
                            this.$set(this.languagesList[indx], "mapper_file_path", entry_info.mapper_file_path)
                        }
                        if('mapper_type' in entry_info){
                            this.$set(this.languagesList[indx], "mapper_type", entry_info.mapper_type)
                        }

                        if ("orientation" in entry_info) {
                            this.$set(this.languagesList[indx], "orientation", entry_info.orientation);
                        }
                    }
                }
            },
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapActions("settings", ["getlangaugesDetailsFromServer", "downloadlangaugesMapperFromServer", "updateLanguageWithResetFromServe", "getSpecificLanguage"]),
            ...mapGetters("users", ["getLoggedInUserPrivilege"])
        }
    }   
</script>

<style scoped lang="scss">
    $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $primary-background: #1a1e21;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $tags-background-color:#282d31;
    $svg-color:#666;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $icon-hover:#2c3339;

    .table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        margin: 0px 15px;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th {
            position: sticky;
            top: 0;
            background: $primary-background;
            z-index: 9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr {
            height: 45px;
            }
            tr:hover{
                background: $bg-color-on-hover !important;
            }
        }
    }

    .table {
        th {
            border-top: none !important;
            padding:0 10px !important;
        }
        td {
            border-top: none !important;
            padding:0 1rem!important;
        }
    }

    th {
        border-top: none !important;
        padding:0 10px !important;
    }

    .table-cell-styles{
        td{
            padding:0 10px !important;
        }
    }

    .table-with-border {
        thead {
            border-bottom: $border-color;
        }
        tr {
            border-bottom: $border-color;
        }
    }

    tr[disabled]{
        color:#6c6c6c !important;
    }

    .language-table-main-wrapper{
        margin-top:20px;
        display: inline-block;
        width: 100%;
        overflow: auto;
        height: calc(100% - 45px);  
        overflow-x:hidden;
    }

    input[type='checkbox']:after{
        line-height: 1.5em;
        content: '';
        display: inline-block;
        width: 22px;
        height: 21px;
        margin-top: 5px;
        margin-inline-start: -1px;
        border: $border-color;
        border-radius: 0.25em;
        background: $primary-background;
    }

    input[type='checkbox']:checked:after{
        content: '✔';
        color: $active-blue !important;
        // position: absolute;
        font-size: 16px;
        line-height: 1;
        transition: all .2s;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px;
        padding-top:2px;
    }

    .show-delete-icon:hover{
        position: relative;
        .parent-row-edit{
            visibility: visible;
        }    
    }
    
    .parent-row-edit{
      margin-inline-start: 3px;
      // position: absolute;
      // inset-inline-end :0px;
      z-index: 1;
      background: #525252;
      border: 1px solid #262626;
      width: 55px;
      height: 44px;
      padding: 12px;
      top: 0px;
      border-radius: 4px;
      visibility: hidden;
      color: #fff;
    }

    .search-bar-comm-style {
        float: inline-start;
        margin-top: 5px;
        display:inline-flex;
        .search-bar{
            background: $primary-background !important;
            height:40px;
            width: 250px !important;
            float: inline-start;
            padding-inline-start: 12px;
            margin: 0;
            margin-inline-end: 3%;  
            padding-bottom:2px;
            border: $border-color !important;
        }
    }

    ::v-deep {
        textarea::placeholder {
        color: grey; /* Change this to your desired color */
        opacity: 1; /* Change this if you need to adjust the opacity */
        }
        .multiselect{
            width:93%;
            margin: 3px 0px;
        }
        .multiselect__tags-wrap{
            display:block;
        }
        .multiselect__content-wrapper{
            display:none;
        }
        .multiselect__tag, .tags-style {
            background-color: $primary-background !important;
            border: $border-color;
            border-radius: 5px;
            margin-bottom:0px;
        }
        .multiselect__tags, .tags-style {
            background: $primary-background !important;
            border: $border-color !important;
        }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
            color:$secondary-text-color !important;
            font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            padding: 2px 35px 2px 6px !important;
            display: flex !important;
            align-items: flex-start;
            flex-direction: column;
            justify-content: center;      
        }

        .multiselect__select{
            width:35px !important;
        }
          
        .multiselect__placeholder {
            // padding-top: 5px !important;
            margin-bottom:0px;
            color:#b7b7b7 !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 36px;
        }
        .multiselect__single{
                margin: 0!important;
                height: 100%;
                display: flex;
                align-items: center;
        }
        .multiselect__option--selected{
            background:$bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100% !important;
            max-height: 120px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
            // width:auto !important;
        }
            
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
            background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background !important;
            height: auto;
        }
          
        input:focus,select:focus,textarea:focus,.multiselect__input:focus,.mx-input:focus{
            outline: none;
            --saf-0: rgba(var(--sk_highlight,18,100,163),1);
            box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
            border-radius: 4px;
            border-color: transparent;
            -webkit-appearance: none;
        }

        .multiselect__tags {
        input:focus,select:focus,textarea:focus,.multiselect__input:focus,.mx-input:focus{
            outline: none;
            --saf-0: rgba(var(--sk_highlight,18,100,163),1);
            box-shadow: none !important;
            border-radius: 4px;
            border-color: transparent;
            -webkit-appearance: none;
            color: #eee !important;
        }  
        input::placeholder{
            color:#7a7a7a !important;
        }
        }
    }    

    /* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}
</style>
